







































import { Component, Vue } from 'vue-property-decorator';

import SingUpService from '@/api/SingupService';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import SelectLoyaltyReward from '@/componentsV2/molecules/SelectLoyaltyReward/SelectLoyaltyReward.vue';
import flagKeys from '@/constants/flagKeys';
import { ERewardsProgramStepSlug } from '../RewardsProgramModal.vue';
import { IBusinessType } from '@/models/business';
import { RewardsProgramFormState } from '@/models/rewards-program';
import {
  isLoyaltyOperationBlocked,
  isLoyaltyOperationHidden
} from '@/utils/loyaltyOperation';
import { isOnlineProvider } from '@/utils/provider';
import segmentIo from '@/utils/segment.io';

export const OPERATION_TYPE_STORAGE_KEY = '@twism:business-operation-type';

@Component({
  components: {
    FilledButton,
    SelectLoyaltyReward
  }
})
export default class Operation extends Vue {
  loading = false;
  signUpService = new SingUpService();

  selected: string = '';

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isValidForm() {
    return !!this.selected;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isChooseLoyalty() {
    return this.flags.includes(flagKeys.addWixMultipleIntegration);
  }

  get defaultSelected(): string {
    return this.rewardsProgramFormData.operationType as string;
  }

  get rewardsProgramFormData() {
    return this.$store.getters[
      'rewardsProgram/getFormData'
    ] as RewardsProgramFormState;
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  filterOptions(item: any) {
    if (isLoyaltyOperationHidden(this.businessInfo.type, item.value))
      return false;
    if (!this.isChooseLoyalty && item.value === IBusinessType.BOTH)
      return false;
    if (
      item.value === IBusinessType.INSTORE &&
      this.businessInfo.coinRewardPercentage === '0.00' &&
      this.currentProvider &&
      isOnlineProvider(this.currentProvider.name)
    )
      return false;
    return true;
  }

  disableOptions(item: any) {
    return isLoyaltyOperationBlocked(this.businessInfo.type, item.value);
  }

  selectLoyalty(value: string) {
    this.selected = value;

    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      operationType: value
    });
  }

  onBack() {
    this.$emit('goToStep', {
      redirectToSlug: ERewardsProgramStepSlug.INTRODUCTION
    });
  }

  async onSubmit() {
    if (!this.isValidForm) {
      this.$notification('Please select an option', 'error');
      return;
    }
    localStorage.setItem(OPERATION_TYPE_STORAGE_KEY, this.selected);

    segmentIo.track('Selected Loyalty Rewards Operation', {
      Operation: this.selected
    });

    this.$emit('changeFlowType', this.selected);
    this.$emit('goToStep', {
      redirectToSlug: this.currentProvider
        ? ERewardsProgramStepSlug.REWARD_RATIO
        : ERewardsProgramStepSlug.OPERATION_POS_SYSTEM
    });
  }

  created() {
    // The saved choice can be an option this business is no longer offered.
    if (
      this.defaultSelected &&
      this.filterOptions({ value: this.defaultSelected }) &&
      !this.disableOptions({ value: this.defaultSelected })
    )
      this.selected = this.defaultSelected;
  }
}
